// TODO: Remove the whole code and "intl" and "intl-support" packages
//       after Safari supports build-in Intl API.
//       Currently, Safari Preview already implements the API.
//       see: https://github.com/yahoo/react-intl/wiki#i18n-in-javascript
//
// Polyfill to adopt non-build-in-Intl-API-supported browsers (ex. Safari)
// see: http://formatjs.io/guides/runtime-environments/

import { shouldPolyfill as shouldPolyfillIntlLocale } from "@formatjs/intl-locale/should-polyfill";
import areIntlLocalsSupported from "intl-locales-supported";

// eslint-disable-next-line @typescript-eslint/no-namespace
declare namespace Intl {
  let NumberFormat: any;
  let DateTimeFormat: any;
  let RelativeTimeFormat: any;
  let PluralRules: any;
  let getCanonicalLocales: any;
}

if (globalThis.Intl) {
  const supportedLocales = ["en", "ja"];

  // Determine if the built-in `Intl` has the locale data we need.
  if (!areIntlLocalsSupported(supportedLocales)) {
    // `Intl` exists, but it doesn't have the data we need, so load the
    // polyfill and patch the constructors we need with the polyfill's.
    const IntlPolyfill = require("intl");
    Intl.NumberFormat = IntlPolyfill.NumberFormat;
    Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
  }

  if (shouldPolyfillIntlLocale()) {
    require("@formatjs/intl-locale/polyfill");
  }

  if (!Intl.RelativeTimeFormat) {
    require("@formatjs/intl-relativetimeformat/polyfill");
    require("@formatjs/intl-relativetimeformat/locale-data/en");
    require("@formatjs/intl-relativetimeformat/locale-data/ja");
  }

  if (!Intl.PluralRules) {
    require("@formatjs/intl-pluralrules/polyfill");
    require("@formatjs/intl-pluralrules/locale-data/en");
    require("@formatjs/intl-pluralrules/locale-data/ja");
  }

  // For IE11 support.
  if (!Intl.getCanonicalLocales) {
    require("@formatjs/intl-getcanonicallocales/polyfill");
  }
} else {
  // No `Intl`, so use and load the polyfill.
  globalThis.Intl = require("intl");
}
